<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="订单id" prop="id">
                <a-input v-model="queryParam.id" placeholder="请输入订单id" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="支付开始时间" prop="payStartTime">
                <a-date-picker
                  style="width: 100%"
                  v-model="queryParam.payStartTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  show-time
                  placeholder="请选择开始时间"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="支付结束时间" prop="payEndTime">
                <a-date-picker
                  style="width: 100%"
                  v-model="queryParam.payEndTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  show-time
                  placeholder="请选择结束时间"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择状态" allow-clear>
                  <a-select-option value="0">待支付</a-select-option>
                  <a-select-option value="1">已支付</a-select-option>
                  <a-select-option value="2">已发货</a-select-option>
                  <a-select-option value="3">已完成</a-select-option>
                  <a-select-option value="4">已售后</a-select-option>
                  <a-select-option value="-1">取消订单</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="类型" prop="type">
                  <a-select v-model="queryParam.type" disabled>
                    <a-select-option :value="1">兑换商城</a-select-option>
                    <a-select-option :value="2">闲橙优选</a-select-option>
                    <a-select-option :value="3">闲橙健康</a-select-option>
                    <a-select-option :value="4">课程订单</a-select-option>
                    <a-select-option :value="5">会员商品</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="类型" prop="type">
                  <a-select v-model="queryParam.type" disabled>
                    <a-select-option :value="1">兑换商城</a-select-option>
                    <a-select-option :value="2">闲橙优选</a-select-option>
                    <a-select-option :value="3">闲橙健康</a-select-option>
                    <a-select-option :value="4">课程订单</a-select-option>
                    <a-select-option :value="5">会员商品</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
<!--              <a-col :md="8" :sm="24">
                <a-form-item label="商品总数" prop="quantity">
                  <a-input v-model="queryParam.quantity" placeholder="请输入商品总数" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="总金额" prop="totalAmount">
                  <a-input v-model="queryParam.totalAmount" placeholder="请输入总金额" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="支付金额" prop="payAmount">
                  <a-input v-model="queryParam.payAmount" placeholder="请输入支付金额" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="运费" prop="freightAmount">
                  <a-input v-model="queryParam.freightAmount" placeholder="请输入运费" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="税费" prop="taxesAmount">
                  <a-input v-model="queryParam.taxesAmount" placeholder="请输入税费" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="上级用户id" prop="distributorUserId">
                  <a-input v-model="queryParam.distributorUserId" placeholder="请输入上级用户id" allow-clear/>
                </a-form-item>
              </a-col>-->
<!--              <a-col :md="8" :sm="24">
                <a-form-item label="支付时间" prop="payTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.payTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="收货地址" prop="addressId">
                  <a-input v-model="queryParam.addressId" placeholder="请输入收货地址" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="收货人姓名" prop="reciverName">
                  <a-input v-model="queryParam.reciverName" placeholder="请输入收货人姓名" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="收货人手机号" prop="reciverTelephone">
                  <a-input v-model="queryParam.reciverTelephone" placeholder="请输入收货人手机号" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="标签(如：公司 ,家,学校 等等)" prop="addressLabel">
                  <a-input v-model="queryParam.addressLabel" placeholder="请输入标签(如：公司 ,家,学校 等等)" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="国家" prop="country">
                  <a-input v-model="queryParam.country" placeholder="请输入国家" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="省份" prop="areap">
                  <a-input v-model="queryParam.areap" placeholder="请输入省份" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="城市" prop="areac">
                  <a-input v-model="queryParam.areac" placeholder="请输入城市" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="县" prop="areax">
                  <a-input v-model="queryParam.areax" placeholder="请输入县" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="详细地址" prop="detailedAddress">
                  <a-input v-model="queryParam.detailedAddress" placeholder="请输入详细地址" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="邮政编码" prop="zipCode">
                  <a-input v-model="queryParam.zipCode" placeholder="请输入邮政编码" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否提醒发货" prop="isWarn">
                  <a-input v-model="queryParam.isWarn" placeholder="请输入是否提醒发货" allow-clear/>
                </a-form-item>
              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['order:order:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['order:order:edit']">
          <a-icon type="edit" />修改
        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['order:order:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['order:order:export']">
          <a-icon type="download" />导出
        </a-button>

        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <info-form
        ref="infoForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['order:order:edit']" />
<!--          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['order:order:edit']">
            <a-icon type="edit" />修改
          </a>-->
          <a @click="$refs.infoForm.handleUpdate(record, undefined)" v-hasPermi="['order:order:query']">
            <a-icon type="info" />查询
          </a>
          <a-divider type="vertical" v-hasPermi="['order:order:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['order:order:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageOrder,listOrder, delOrder } from '@/api/order/order'
import CreateForm from './modules/CreateForm'
import InfoForm from "./modules/InfoForm";
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Order',
  components: {
    CreateForm,
    InfoForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        orderNo: null,
        payStartTime: null,
        payEndTime: null,
        dateRange: [],
        outTrandNo: null,
        userId: null,
        status: null,
        refundStatus: null,
        quantity: null,
        totalAmount: null,
        payAmount: null,
        freightAmount: null,
        taxesAmount: null,
        distributorUserId: null,
        payType: null,
        payTime: null,
        addressId: null,
        reciverName: null,
        sex: null,
        reciverTelephone: null,
        addressLabel: null,
        country: null,
        areap: null,
        areac: null,
        areax: null,
        detailedAddress: null,
        zipCode: null,
        isWarn: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        /*{
          title: '订单ID',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '三方订单号',
          dataIndex: 'outTrandNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户名称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (text === 0) {
              return '待支付'
            } else if (text === 1) {
              return '已支付'
            } else if (text === 2) {
              return '已发货'
            } else if (text === 3) {
              return '已完成'
            } else if (text === 4) {
              return '已售后'
            } else if (text === -1) {
              return '已取消'
            }
          }
        },
        {
          title: '售后状态',
          dataIndex: 'refundStatus',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (text === 0) {
              return '待申请'
            } else if (text === 1) {
              return '部分售后'
            } else if (text === 2) {
              return '售后中'
            } else if (text === 3) {
              return '已完成'
            }
          }
        },
        {
          title: '商品总数',
          dataIndex: 'quantity',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '总金额',
          dataIndex: 'totalAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '支付金额',
          dataIndex: 'payAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '运费',
          dataIndex: 'freightAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '税费',
          dataIndex: 'taxesAmount',
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: '上级用户id',
          dataIndex: 'distributorUserId',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '支付类型',
          dataIndex: 'payType',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (text === 0) {
              return '余额'
            } else if (text === 1) {
              return '微信'
            } else if (text === 2) {
              return '支付宝'
            }
          }
        },
        {
          title: '支付时间',
          dataIndex: 'payTime',
          scopedSlots: { customRender: 'payTime' },
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: '收货地址',
          dataIndex: 'addressId',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '收货人姓名',
          dataIndex: 'reciverName',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '性别,0-保密 1-男 2-女',
          dataIndex: 'sex',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '收货人手机号',
          dataIndex: 'reciverTelephone',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '标签(如：公司 ,家,学校 等等)',
          dataIndex: 'addressLabel',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '国家',
          dataIndex: 'country',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '省份',
          dataIndex: 'areap',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '城市',
          dataIndex: 'areac',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '县',
          dataIndex: 'areax',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '详细地址',
          dataIndex: 'detailedAddress',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '邮政编码',
          dataIndex: 'zipCode',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '是否提醒发货',
          dataIndex: 'isWarn',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询订单信息列表 */
    getList () {
      this.loading = true
      const { payStartTime, payEndTime } = this.queryParam;
      console.log('============', this.queryParam.payStartTime)
      console.log('============', this.queryParam.payEndTime)
      if (payStartTime && !payEndTime) {
        this.$message.warning("请选择支付结束时间")
        return;
      }
      if (!payStartTime && payEndTime) {
        this.$message.warning("请选择支付开始时间")
        return;
      }
      if (payStartTime && payEndTime) {
        // this.queryParam.dateRange = [
        //   this.parseTime(this.queryParam.payStartTime, '{y}-{m}-{d} {h}:{i}:{s}'),
        //   this.parseTime(this.queryParam.payEndTime, '{y}-{m}-{d} {h}:{i}:{s}')
        // ]
        this.queryParam.dateRange = [this.queryParam.payStartTime, this.queryParam.payEndTime]

      }




      delete this.queryParam.payStartTime
      delete this.queryParam.payEndTime

     pageOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        orderNo: undefined,
        payStartTime: undefined,
        payEndTime: undefined,
        outTrandNo: undefined,
        userId: undefined,
        status: undefined,
        refundStatus: undefined,
        quantity: undefined,
        totalAmount: undefined,
        payAmount: undefined,
        freightAmount: undefined,
        taxesAmount: undefined,
        distributorUserId: undefined,
        payType: undefined,
        payTime: undefined,
        addressId: undefined,
        reciverName: undefined,
        sex: undefined,
        reciverTelephone: undefined,
        addressLabel: undefined,
        country: undefined,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        detailedAddress: undefined,
        zipCode: undefined,
        isWarn: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delOrder(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('order/order/export', {
            ...that.queryParam
          }, `订单信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },

  }
}
</script>
